module.exports = __webpack_public_path__ + "static/media/diary.1cb7b35f.svg";